import React from "react";
import {
  Box,
  Paper,
  Typography,
  Chip,
  Stack,
  Divider,
  Alert,
} from "@mui/material";
import {
  Visibility,
  ShoppingBag,
  LocationOn,
  Event,
  Person,
  Warning, // Para reclamos
  Cancel, // Para rechazos
  Schedule, // Para pospuestos
   Block,
} from "@mui/icons-material";

function DetallePedido({ row }) {
  const productos = row.producto 
    ? row.producto.split(" -- ").map(item => item.trim()).filter(item => item)
    : [];
     
  // Configuración para cada tipo de observación
  const observacionesConfig = {
    reclamo: {
      icon: Warning,
      title: "Reclamo del pedido",
      color: "error",
      bgcolor: "error.light",
      field: "obs_reclamo"
    },
    rechazo: {
      icon: Cancel,
      title: "Motivo de rechazo",
      color: "error", 
      bgcolor: "error.light",
      field: "desc_motivo_rechazo"
    },
    pospuesto: {
      icon: Schedule,
      title: "Motivo de posposición",
      color: "warning",
      bgcolor: "warning.light",
      field: "obs_pospuesto"
    },
    anulado: { // AGREGAR ESTE NUEVO
    icon: Block,
    title: "Motivo de anulación",
    color: "error", 
    bgcolor: "error.light",
    field: "obs_anulado"
  }
  };

  // Función para renderizar cada tipo de observación
  const renderObservacion = (tipo) => {
    const config = observacionesConfig[tipo];
    const valor = row[config.field];
    
    if (!valor) return null;

    const IconComponent = config.icon;

    return (
      <Alert 
        severity={config.color}
        icon={<IconComponent />}
        sx={{
          mb: 1,
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <Typography variant="subtitle2" fontWeight="600" gutterBottom>
          {config.title}
        </Typography>
        <Typography variant="body2">
          {valor}
        </Typography>
      </Alert>
    );
  };

  return (
    <Paper 
      sx={{ 
        p: 1.5,
        mx: 1,
        mb: 1,
        backgroundColor: 'grey.50',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        maxWidth: 'calc(100% - 16px)',
        boxSizing: 'border-box'
      }}
      elevation={0}
    >
      <Stack spacing={1.5}>
        {/* Observaciones especiales (reclamo, rechazo, pospuesto) */}
        {(row.obs_reclamo || row.desc_motivo_rechazo || row.obs_pospuesto || row.obs_anulado) && (
          <Box>
            {renderObservacion('reclamo')}
            {renderObservacion('rechazo')}
            {renderObservacion('pospuesto')}
            {renderObservacion('anulado')}
          </Box>
        )}

        {/* Observaciones generales */}
        {row.observaciones && (
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Visibility color="primary" sx={{ fontSize: 18 }} />
              <Typography variant="subtitle2" fontWeight="600" color="text.primary">
                Observaciones
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ pl: 3 }}>
              {row.observaciones}
            </Typography>
          </Box>
        )}

        {/* Productos */}
        {productos.length > 0 && (
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <ShoppingBag color="primary" sx={{ fontSize: 18 }} />
              <Typography variant="subtitle2" fontWeight="600" color="text.primary">
                Productos ({productos.length})
              </Typography>
            </Box>
            <Box sx={{ pl: 3 }}>
              {productos.map((producto, index) => (
                <Chip
                  key={index}
                  label={producto}
                  size="small"
                  variant="outlined"
                  sx={{ 
                    mr: 0.5, 
                    mb: 0.5,
                    fontSize: '0.75rem',
                    height: 24
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

        {/* Información adicional en línea */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, pt: 0.5 }}>
          {row.direccion_entrega && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {row.direccion_entrega}
              </Typography>
            </Box>
          )}
          
          {row.fecha_para && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Event sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {row.fecha_para}
              </Typography>
            </Box>
          )}
          
          {row.nombre_apellido && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Person sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="caption" color="text.secondary">
                {row.nombre_apellido}
              </Typography>
            </Box>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}

export default DetallePedido;